var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16683 0.833496H2.50016C2.05814 0.833496 1.63421 1.00909 1.32165 1.32165C1.00909 1.63421 0.833496 2.05814 0.833496 2.50016V12.5002C0.833496 12.9422 1.00909 13.3661 1.32165 13.6787C1.63421 13.9912 2.05814 14.1668 2.50016 14.1668H12.5002C12.9422 14.1668 13.3661 13.9912 13.6787 13.6787C13.9912 13.3661 14.1668 12.9422 14.1668 12.5002V4.0235C14.1667 3.5815 13.9911 3.15765 13.6785 2.84516L12.1552 1.32183C11.8427 1.00925 11.4188 0.83359 10.9768 0.833496H10.0002M4.16683 0.833496V4.16683C4.16683 4.38784 4.25463 4.5998 4.41091 4.75608C4.56719 4.91237 4.77915 5.00016 5.00016 5.00016H9.16683C9.38784 5.00016 9.5998 4.91237 9.75608 4.75608C9.91237 4.5998 10.0002 4.38784 10.0002 4.16683V0.833496M4.16683 0.833496H10.0002M3.3335 11.6668V9.16683C3.3335 8.94582 3.42129 8.73385 3.57757 8.57757C3.73385 8.42129 3.94582 8.3335 4.16683 8.3335H10.8335C11.0545 8.3335 11.2665 8.42129 11.4228 8.57757C11.579 8.73385 11.6668 8.94582 11.6668 9.16683V11.6668",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.ecfba55cdd0a8978e97eb1d17b3b4b4e.svg";
export { ForwardRef as ReactComponent };